import CircularProgress from '@mui/material/CircularProgress';
import React, { useCallback, useEffect, useRef, useState } from 'react';
// import style from './index.module.scss';
import user from '@/stores/user';
import { useConnectModal } from '@rainbow-me/rainbowkit';
import cx from 'classnames';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

const StyledButton = styled.button`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    outline: none;
    cursor: pointer;
    color: #000;
    border-radius: 12px;

    border-radius: 12px;

    &:hover {
        background-color: #000;
    }
    &.small {
        height: 40px;

        font-size: 12px;
        width: fit-content;
        padding: 0 20px;
    }

    &.middle {
        padding: 15px;
        font-size: 16px;

        height: 48px;
        width: 160px;
    }

    &.normal {
        padding: 15px 24px;
        font-size: 18px;
        height: 56px;

        box-sizing: border-box;
        font-weight: 500;
        min-width: 180px;

        ${({ theme }) => theme.mediaWidth.upToSmall`
        height 48px;
        font-size: 16px;
        padding: 10px 20px;
        min-width: unset;
        `};
    }

    &.primary {
        background: #000;
        /* box-shadow: 2px 10px 10px 0px rgba(219, 154, 50, 0.3); */
        color: #fff;
    }

    &.transparent {
        background: transparent;
        color: #000;

        &:hover,
        &:focus,
        &:active {
            color: #000;
        }
    }

    &.outline {
        background: transparent;

        border: 1px solid #000 !important;
        color: #000 !important;
    }
    &.outlineWhite {
        background: transparent;

        border: 1px solid #fff;
        color: #fff;
    }

    &.disabled {
        /* background: #fdd436; */
        opacity: 0.6;
        border-image: none;
        box-shadow: none;
        cursor: not-allowed;

        &:hover,
        &:focus,
        &:active {
            border-image: none;
            box-shadow: none;
            cursor: not-allowed;
        }
    }

    &.loading {
        color: transparent !important;
    }

    .loadingIcon {
        position: absolute;
        // top: 50%;
        // left: 50%;
        // margin-top: -50%;
        // margin-left: -50%;
        color: #000;
    }
`;

const AuthButton = styled(StyledButton)`
    background: #000 !important;
    color: #fff !important;
`;
export interface Props {
    size?: 'middle' | 'normal' | 'small';
    type?: 'primary' | 'transparent' | 'outline' | 'outlineWhite';
    disabled?: boolean;
    children?: React.ReactNode;
    className?: string;
    showLoading?: boolean;
    loadingProps?: {
        classname?: string;
        size?: number;
    };
    style?: React.CSSProperties;
    auth?: boolean;
    onClick?:
        | ((event?: React.SyntheticEvent) => void)
        | ((event?: React.SyntheticEvent) => Promise<any>);
}

function Button(props: Props) {
    const { openConnectModal } = useConnectModal();
    const {
        size = 'normal',
        type = 'primary',
        disabled,
        children,
        className,
        onClick,
        showLoading = true,
        loadingProps = {
            classname: '',
            size: 24,
        },
        auth,
        ...rest
    } = props;
    const [loading, setLoading] = useState(false);
    const loadingRef = useRef(loading);
    const mountedRef = useRef(true);

    loadingRef.current = loading;

    const handleLoading = useCallback(
        (value: any) => {
            if (mountedRef.current) {
                setLoading(value);
            }
        },
        [setLoading],
    );

    const handleClick = useCallback(
        (event: any) => {
            if (loadingRef.current || disabled || !onClick) {
                return;
            }

            const promise = onClick(event);
            if (
                promise != null &&
                typeof (promise as Promise<any>).then === 'function'
            ) {
                handleLoading(true);
                (promise as Promise<any>)
                    .then((result: any) => {
                        handleLoading(false);
                        return result;
                    })
                    .catch((e) => {
                        handleLoading(false);
                    });
            }
        },
        [loadingRef, mountedRef, disabled, handleLoading, onClick],
    );

    useEffect(() => {
        mountedRef.current = true;

        return () => {
            mountedRef.current = false;
        };
    }, []);

    const classes = [
        size,
        type,
        auth && !user.connected ? '' : disabled && 'disabled',
        loading && showLoading && 'loading',
        className,
    ];

    return auth && !user.connected ? (
        <AuthButton
            className={classes.join(' ')}
            onClick={openConnectModal}
            {...rest}
        >
            Connect Wallet
        </AuthButton>
    ) : (
        <StyledButton
            className={classes.join(' ')}
            onClick={handleClick}
            {...rest}
        >
            {children}
            {showLoading && loading && (
                <CircularProgress
                    size={loadingProps.size}
                    className={cx('loadingIcon', loadingProps.classname)}
                />
            )}
        </StyledButton>
    );
}
export default observer(Button);
